import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ADMIN_ROLE, USER_ROLE } from 'utils/auth';

export const checkViewerPermissions = (roles: String[]) =>
  roles.some((role) => role === USER_ROLE || role === ADMIN_ROLE);

export interface AuthState {
  roles: String[];
  userInfo: Record<any, any>;
  isManager: boolean;
}

const initialState: AuthState = {
  roles: [],
  userInfo: {},
  isManager: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    addRoles: (state, action: PayloadAction<String[]>) => {
      state.roles = action.payload;
    },
    addUserInfo: (state, action: PayloadAction<any>) => {
      state.userInfo = action.payload;
    },
    checkManager: (state, action: PayloadAction<boolean>) => {
      state.isManager = action.payload;
    },
  },
});

export const { addRoles, addUserInfo, checkManager } = authSlice.actions;

export const authReducer = authSlice.reducer;
